/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from '../utils/async_utils';
import { FETCH_AVAILABILITY } from '../constants/actions';
import * as api from '../api/index';

export const fetchAvailability = makeAsyncAction(
    FETCH_AVAILABILITY,
    (id: string, year: string) => () => api.fetchAvailability(id, year)
);
